import reactComponentLoader from 'scripts/react-component-loader'

import { Markdown } from './'
import { ArticleShell } from './ArticleShell'

reactComponentLoader(Markdown, '[data-markdown-content]')
reactComponentLoader(ArticleShell, '[data-article-shell]')
